export default __webpack_public_path__ + "static/media/parking-brake.ad29f92e.svg";